import {mediaUrl, fileUrl} from '../constants/constants'


export default (src, type = 'media') => {
    if(type === 'document'){
        return fileUrl + src
    }else{
        return mediaUrl + src
    }
}